import apiClient from './index';

const astroApi = {
  /**
   * Get a list of astronomical tables with their metadata
   */
  getAstroTables: async () => {
    try {
      const response = await apiClient.get('/adss/v1/astro/tables');
      return response.data;
    } catch (error) {
      console.error('Error fetching astronomical tables:', error);
      throw error;
    }
  },

  /**
   * Get a specific astronomical table by ID (admin only)
   */
  getAstroTable: async (tableId) => {
    try {
      const response = await apiClient.get(`/adss/v1/astro/tables/${tableId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching astronomical table:', error);
      throw error;
    }
  },

  /**
   * Perform a cone search query on an astronomical table
   */
  performConeSearch: async (schemaTable, ra, dec, radius, limit = 100, columns = null) => {
    try {
      const response = await apiClient.post('/adss/v1/astro/cone-search', {
        schema_table: schemaTable,
        ra,
        dec,
        radius,
        limit,
        important_columns: columns
      });
      return response.data;
    } catch (error) {
      console.error('Error performing cone search:', error);
      throw error;
    }
  },

  /**
   * Get detailed information about a specific astronomical object
   */
  getObjectDetail: async (schemaTable, idColumn, idValue) => {
    try {
      const response = await apiClient.post('/adss/v1/astro/object-detail', {
        schema_table: schemaTable,
        id_column: idColumn,
        id_value: idValue
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching object details:', error);
      throw error;
    }
  },

  /**
   * Get astronomical object by coordinates
   * Returns the closest object within the specified radius
   */
  getObjectByCoordinates: async (schemaTable, ra, dec, radius = 0.005) => {
    try {
      const response = await apiClient.get(
        `/adss/v1/astro/object-by-coords/${schemaTable}/${ra}/${dec}`,
        { params: { radius } }
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching object by coordinates:', error);
      throw error;
    }
  },

  /**
   * Add a new astronomical table (admin only)
   */
  addAstroTable: async (tableData) => {
    try {
      const response = await apiClient.post('/adss/v1/astro/tables', tableData);
      return response.data;
    } catch (error) {
      console.error('Error adding astronomical table:', error);
      throw error;
    }
  },

  /**
   * Modify an existing astronomical table (admin only)
   */
  modifyAstroTable: async (tableId, tableData) => {
    try {
      const response = await apiClient.put(`/adss/v1/astro/tables/${tableId}`, tableData);
      return response.data;
    } catch (error) {
      console.error('Error modifying astronomical table:', error);
      throw error;
    }
  },

  /**
   * Delete an astronomical table metadata (admin only)
   */
  deleteAstroTable: async (schemaName, tableName) => {
    try {
      const response = await apiClient.delete(`/adss/v1/astro/tables/${schemaName}/${tableName}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting astronomical table:', error);
      throw error;
    }
  },

  /**
   * Get time series data for an object (if available)
   * Note: This is a placeholder for future implementation
   */
  getTimeSeriesData: async (schemaTable, objectId) => {
    try {
      // This would be a real API call in the final implementation
      // const response = await apiClient.get(`/adss/v1/astro/timeseries/${schemaTable}/${objectId}`);
      // return response.data;
      
      // For now, return mock data based on objectId to make it seem dynamic
      const seed = parseInt(objectId.toString().replace(/[^0-9]/g, '')) || 1234;
      const mockData = [];
      
      // Generate mock data for two filters
      ['g', 'r'].forEach((filter, filterIndex) => {
        const baseValue = 15 - filterIndex * 0.5; // g = ~15, r = ~14.5
        
        // Generate data points over a period
        for (let i = 0; i < 20; i++) {
          // Use the seed and day to generate a consistent random value
          const randomFactor = Math.sin(seed * i * 0.1) * 0.2;
          
          mockData.push({
            time: new Date(2022, 0, i + 1).toISOString().split('T')[0], // 2022-01-01, etc.
            value: baseValue + randomFactor,
            filter: filter
          });
        }
      });
      
      return { timeSeriesData: mockData };
    } catch (error) {
      console.error('Error fetching time series data:', error);
      throw error;
    }
  }
};

export default astroApi;